document.addEventListener('DOMContentLoaded', function() {
  // Initialize accordions in collection descriptions
  function initCollectionAccordions() {
    var acc = document.getElementsByClassName("accordion");
    var panels = document.getElementsByClassName("panel");

    for (let i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function () {
        this.classList.toggle("active");

        let panel = panels[i];

        if (panel.style.display === "block") {
          panel.style.display = "none";
        } else {
          panel.style.display = "block";
        }
      });
    }
  }
  
  // Run on page load
  initCollectionAccordions();
  
  // Re-run when collection content is dynamically loaded
  document.addEventListener('shopify:section:load', initCollectionAccordions);
});